import { ButtonSizeOptions } from "@loanbossinc/component-library";
import { FormControlLabel, Radio } from "@material-ui/core";
import { withFormik } from "formik";
import React, { useEffect } from "react";

import DocIcon from "../../docIcon.svg";

import {
  Avatar,
  BackButton,
  Banner,
  BannerItem,
  ButtonBar,
  DealName,
  IconWrapper,
  ReportName,
  StepHeader,
  StyledPrimaryButton,
  Title,
  WorkflowLinkContent,
  WorkflowLinkIcon,
  WorkflowLinkWrapper
} from "./styles";

export const Step1 = props => {
  const {
    deal,
    handleSubmit,
    history,
    isSubmitting,
    values,
    setFieldValue,
    reportConfig: { reportName }
  } = props;

  const { shouldTrackByPortfolio, shouldTrackIndividualProperty } = values;

  useEffect(() => {
    if (!shouldTrackByPortfolio && !shouldTrackIndividualProperty) {
      setFieldValue("shouldTrackByPortfolio", true);
    }
  }, [shouldTrackByPortfolio, shouldTrackIndividualProperty]);

  const handlePortfolioSelection = event => {
    setFieldValue("shouldTrackByPortfolio", event.target.checked || true);
    setFieldValue("shouldTrackIndividualProperty", false);
  };

  const handlePropertySelection = event => {
    setFieldValue("shouldTrackIndividualProperty", event.target.checked || true);
    setFieldValue("shouldTrackByPortfolio", false);
  };

  const handleGoBack = () => history.goBack();

  return (
    <>
      <Banner>
        <BannerItem>
          <DealName>{deal && deal.name}</DealName>
          <ReportName>{reportName}</ReportName>
          <Title>Adjusted Net Operating Income</Title>
        </BannerItem>
        <BannerItem>
          <Avatar>
            <IconWrapper>
              <img src={DocIcon} alt="Doc Logo" />
            </IconWrapper>
          </Avatar>
        </BannerItem>
      </Banner>
      <StepHeader>
        This deal has more than one property.
        <p>How do you keep track of accounting information?</p>
      </StepHeader>

      <WorkflowLinkWrapper id="calc-as-portfolio" onClick={handlePortfolioSelection}>
        <WorkflowLinkIcon>
          <FormControlLabel
            onChange={handlePortfolioSelection}
            value="shouldTrackByPortfolio"
            control={<Radio color="primary" checked={shouldTrackByPortfolio} />}
          />
        </WorkflowLinkIcon>
        <WorkflowLinkContent>I track revenue and expenses for each property as a portfolio</WorkflowLinkContent>
      </WorkflowLinkWrapper>

      <WorkflowLinkWrapper id="calc-as-individual-prop" onClick={handlePropertySelection}>
        <WorkflowLinkIcon>
          <FormControlLabel
            onChange={handlePropertySelection}
            value="shouldTrackIndividualProperty"
            control={<Radio color="primary" checked={shouldTrackIndividualProperty} />}
          />
        </WorkflowLinkIcon>
        <WorkflowLinkContent>I track revenue and expenses for each property separately </WorkflowLinkContent>
      </WorkflowLinkWrapper>

      <ButtonBar>
        <BackButton onClick={handleGoBack} id="back-button" label="Back" iconName="arrow_forward" reverse alignRight={false} key={1} />
        <StyledPrimaryButton disabled={isSubmitting} onClick={handleSubmit} size={ButtonSizeOptions.sm} label="Next" />
      </ButtonBar>
    </>
  );
};

export default withFormik({
  mapPropsToValues: ({ shouldTrackByPortfolio, shouldTrackIndividualProperty }) => ({ shouldTrackByPortfolio, shouldTrackIndividualProperty }),
  handleSubmit(values, { props, setSubmitting }) {
    const {
      wizardStepIncrement,
      setNoiSelections,
      history,
      deal,
      reportConfig: { id }
    } = props;
    setNoiSelections(values);
    setSubmitting(false);
    /*
     * wizardStepIncrement();
     * TODO: Should be redirected to appropriated NOI report component
     * history.push(`/deal/${deal.id}/lender-reports/${id}/noi-calculation/${reportComponentId}`)
     */
    history.push(`/deal/${deal.id}/lender-reports/c1d509e6-8501-4882-8c1e-85df474fc29e/noi-calculation`);
  }
})(Step1);
